import React, { useState, useEffect } from "react";
import {
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Paper,
  TableContainer,
  Button,
  Grid,
  Divider,
  Autocomplete,
  TextField,
  TablePagination,
} from "@mui/material";
import Breadcrumb from "src/layouts/full/shared/breadcrumb/Breadcrumb";
import PageContainer from "src/components/container/PageContainer";
import ParentCard from "src/components/shared/ParentCard";
import * as XLSX from "xlsx";
import { IconFileDownload, IconPlus } from "@tabler/icons";

import GeofencingService from "src/service/geofencing";
import CustomFormLabel from "src/components/forms/theme-elements/CustomFormLabel";
import { useNavigate } from "react-router";
import GeofencingSetupService from "src/service/geofenceSetup";
import { Link } from "react-router-dom";
import ModeEditOutlinedIcon from "@mui/icons-material/ModeEditOutlined";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import swal from "sweetalert";

const BCrumb = [
  {
    to: "/",
    title: "Home",
  },
  {
    title: "Home Site Location",
  },
];

const HomeSiteFenceList = () => {
  const sessionData = JSON.parse(localStorage.getItem("user"));
  const [fence_report, setFenceAllotmentReport] = useState([]);
  const [vehicle_list, setvehicleList] = useState([]);
  const [selectedVehicle, setSelectedVehicle] = useState("");

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const navigate = useNavigate();

  const fetchVehicleNoData = async () => {
    try {
      const res = await GeofencingService.fetch_vehicle_list({});
      setvehicleList(res.data);
    } catch (error) {
      console.log(error);
    }
  };

  const filteredData = fence_report.filter((item) => {
    return selectedVehicle ? item.vehicle_no === selectedVehicle : true;
  });

  const paginatedData = filteredData.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  const fetch_locationwise_geofence_report = async () => {
    try {
      const res = await GeofencingSetupService.get_location_wise_list({
        vehicle_no: selectedVehicle,
        geo_fence_type: 2,
      });
      setFenceAllotmentReport(res.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetch_locationwise_geofence_report();
    fetchVehicleNoData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    fetch_locationwise_geofence_report(selectedVehicle);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedVehicle]);

  const exportVisibleDataToExcel = () => {
    const table = document.getElementById("allotment_report_table");
    if (!table) {
      alert("Table not found");
      return;
    }

    const rows = [];

    for (let i = 0; i < table.rows.length; i++) {
      const row = [];
      const currentRow = table.rows[i];

      for (let j = 0; j < currentRow.cells.length; j++) {
        const cell = currentRow.cells[j];
        row.push(cell.textContent);
      }

      rows.push(row);
    }

    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.aoa_to_sheet(rows);

    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

    const wbout = XLSX.write(wb, { type: "binary", bookType: "xlsx" });

    const fileName = "Home Site Location.xlsx";
    const dataBlob = new Blob([s2ab(wbout)], {
      type: "application/octet-stream",
    });

    if (window.navigator.msSaveBlob) {
      window.navigator.msSaveOrOpenBlob(dataBlob, fileName);
    } else {
      const url = window.URL.createObjectURL(dataBlob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  const s2ab = (s) => {
    const buf = new ArrayBuffer(s.length);
    const view = new Uint8Array(buf);
    for (let i = 0; i < s.length; i += 1) view[i] = s.charCodeAt(i) & 0xff;
    return buf;
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const delete_location_geofence = async (id) => {
    swal({
      title: "Delete Geofence ",
      text: "Are you sure you want to delete this geofencing?",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then(async (willDelete) => {
      if (willDelete) {
        try {
          const response = await GeofencingSetupService.delete_geofencing_data({
            id: id,
            d_by: sessionData.data.id,
          });
          if (response.status === 200) {
            swal("success", response.message, "success");
            fetch_locationwise_geofence_report();
          } else {
            swal("Error", response.message, "error");
          }
        } catch (error) {
          swal("Error", error, "error");
        }
      }
    });
  };

  return (
    <PageContainer title="Geofencing" description="this is Basic Table page">
      <Breadcrumb title="Home Site Location" items={BCrumb} />

      <ParentCard title="">
        <Grid container alignItems="center">
          <Grid
            item
            xs={8}
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              gap: 2,
              marginBottom: "15px;",
              marginTop: "15px;",
            }}
          >
            <Typography
              style={{
                fontSize: "22px",
                fontWeight: "bold",
                fontFamily: "Sans-Serif",
              }}
              variant="h2"
            >
              Home Site Location
            </Typography>
          </Grid>
          <Grid
            item
            xs={4}
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 2,
              marginBottom: "15px;",
              marginTop: "15px;",
            }}
          >
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                navigate("/addhomesitefencelist");
              }}
            >
              <IconPlus width={20} />
            </Button>

            <Button
              variant="contained"
              color="success"
              onClick={exportVisibleDataToExcel}
            >
              <IconFileDownload width={20} />
            </Button>
          </Grid>
        </Grid>
        <Divider />
        <Grid container alignItems="center" style={{ marginTop: "10px" }}>
          <Grid
            item
            container
            xs={12}
            style={{ paddingBottom: "20px" }}
            alignItems="center"
            spacing={2}
          >
            <Grid item lg={4} md={6} sm={6} xs={12}>
              <CustomFormLabel>
                Vehicle No <span style={{ color: "red" }}>*</span>
              </CustomFormLabel>
              <Autocomplete
                id="vehicle_no"
                name="vehicle_no"
                options={vehicle_list}
                getOptionLabel={(option) => option.vehicle_no}
                value={
                  vehicle_list.find(
                    (option) => option.vehicle_no === selectedVehicle
                  ) || null
                }
                onChange={(event, newValue) =>
                  setSelectedVehicle(newValue ? newValue.vehicle_no : "")
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    placeholder="Select Vehicle No"
                    fullWidth
                  />
                )}
              />
            </Grid>
          </Grid>
        </Grid>
        <Paper variant="outlined">
          <TableContainer>
            <Table
              id="allotment_report_table"
              aria-label="simple table"
              sx={{
                whiteSpace: "nowrap",
              }}
            >
              <TableHead style={{ backgroundColor: "silver" }}>
                <TableRow>
                  <TableCell>
                    <Typography
                      style={{ fontSize: "14px", textAlign: "center" }}
                      variant="h6"
                    >
                      Sl. No
                    </Typography>
                  </TableCell>

                  <TableCell>
                    <Typography
                      style={{ fontSize: "14px", textAlign: "center" }}
                      variant="h6"
                    >
                      Vehicle No
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      style={{ fontSize: "14px", textAlign: "center" }}
                      variant="h6"
                    >
                      Place Name
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      style={{ fontSize: "14px", textAlign: "center" }}
                      variant="h6"
                    >
                      Radius (In KM)
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      style={{ fontSize: "14px", textAlign: "center" }}
                      variant="h6"
                    >
                      Send Alert
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      style={{ fontSize: "14px", textAlign: "center" }}
                      variant="h6"
                    >
                      Email Id
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      style={{ fontSize: "14px", textAlign: "center" }}
                      variant="h6"
                    >
                      Action
                    </Typography>
                  </TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {paginatedData.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={7}>
                      <Typography
                        style={{
                          fontSize: "14px",
                          textAlign: "center",
                          color: "red",
                        }}
                        variant="h6"
                      >
                        No records found
                      </Typography>
                    </TableCell>
                  </TableRow>
                ) : (
                  paginatedData.map((item, index) => (
                    <TableRow key={item.id}>
                      <TableCell>
                        <Typography
                          style={{ fontSize: "14px", textAlign: "center" }}
                          variant="h6"
                        >
                          {index + 1 + page * rowsPerPage}
                        </Typography>
                      </TableCell>

                      <TableCell>
                        <Typography
                          style={{ fontSize: "14px", textAlign: "center" }}
                          variant="h6"
                        >
                          {item.vehicle_no !== null ? item.vehicle_no : "NA"}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography
                          style={{ fontSize: "14px", textAlign: "center" }}
                          variant="h6"
                        >
                          {item.location_name !== null
                            ? item.location_name
                            : "NA"}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography
                          style={{ fontSize: "14px", textAlign: "center" }}
                          variant="h6"
                        >
                          {item.radius !== null ? item.radius : "NA"}
                        </Typography>
                      </TableCell>

                      <TableCell>
                        <Typography
                          style={{ fontSize: "14px", textAlign: "center" }}
                          variant="h6"
                        >
                          {item.alert_status === "1"
                            ? "Yes"
                            : item.alert_status === "2"
                            ? "No"
                            : "NA"}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography
                          style={{ fontSize: "14px", textAlign: "center" }}
                          variant="h6"
                        >
                          {item.email_id !== null ? item.email_id : "NA"}
                        </Typography>
                      </TableCell>

                      <TableCell
                        style={{ fontSize: "13px", textAlign: "center" }}
                      >
                        <Link to={`/updatehomesitefencelist/${item.id}`}>
                          <ModeEditOutlinedIcon
                            style={{
                              color: "blue",
                              fontSize: "18px",
                              cursor: "pointer",
                            }}
                          />
                        </Link>

                        <DeleteOutlinedIcon
                          style={{
                            color: "red",
                            fontSize: "18px",
                            marginLeft: "10px",
                            cursor: "pointer",
                          }}
                          onClick={() => delete_location_geofence(item.id)}
                        />
                      </TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[5, 10, 25, 50, 100, 250, 500]}
            component="div"
            count={filteredData.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Paper>
      </ParentCard>
    </PageContainer>
  );
};

export default HomeSiteFenceList;
